import React from "react";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import { QuizChooseItem } from "~/modules/QuizChooseItem";

const Theme23Task1 = () => {
  const items: { name: string; image?: string }[] = [
    {
      name: "У Немецкой слободы"
    },
    {
      name: "У Московского университета"
    },
    {
      name: "В Кремле"
    },
    {
      name: "В Коломенском дворце"
    }
  ];
  return (
    <QuizWrapper
      title='Тест'
      icon='test'
      subtitle='Где устроили особую Государеву аптеку?'
      description='Выбери правильный ответ'
      successIcon='rus-1'
    >
      <QuizChooseItem type='str' items={items} correctItem='В Кремле' />
    </QuizWrapper>
  );
};

export default Theme23Task1;
